import styled from 'styled-components';

import colors from 'styles/theme/colors';

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${colors.purple100}1A;
  background: ${colors.ai10};
`;
